import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PropertyProvider } from "@/context/PropertyContext";
import { Loader } from "@/components/shared";
import Layout from "@/components/Layout";
import Digest from "@/pages/Digest";
import Leaderboard from "@/pages/Leaderboard";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Rooms from "@/pages/Rooms";
import Energy from "@/pages/Energy";
import Occupancy from "@/pages/Occupancy";
import Alerts from "@/pages/Alerts";
import Scenes from "@/pages/Scenes";
import Tickets from "@/pages/Tickets";
import Properties from "@/pages/Properties";
import Users from "@/pages/Users";
import Reports from "@/pages/Reports";
import SuperAdmin from "@/pages/SuperAdmin";
import InvestorPack from "@/pages/InvestorPack";
import GuestApp from "@/pages/GuestApp";
import StaffApp from "@/pages/StaffApp";

function Gate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-background"><Loader /></div>;
  if (!user) return <Login />;
  if (user.role === "guest") return <GuestApp standalone />;

  return (
    <PropertyProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/rooms" element={<Rooms />} />
          <Route path="/energy" element={<Energy />} />
          <Route path="/occupancy" element={<Occupancy />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/scenes" element={<Scenes />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/users" element={<Users />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/super-admin" element={<SuperAdmin />} />
          <Route path="/investor" element={<InvestorPack />} />
          <Route path="/digest" element={<Digest />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/guest-app" element={<GuestApp />} />
          <Route path="/staff-app" element={<StaffApp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </PropertyProvider>
  );
}

export default function App() {
  return (
    <div className="App">
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem storageKey="md_theme" disableTransitionOnChange={false}>
        <LanguageProvider>
          <AuthProvider>
            <BrowserRouter>
              <Gate />
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </div>
  );
}
